import { Alert, AlertIcon, Stack, Text } from "@chakra-ui/react";
import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import { PreviousSigningOutcome } from "../../../../autogen/bff-api";
import { useDesignContestEntry } from "./designContestEntry";

interface Props {
  outcome: PreviousSigningOutcome;
}

const titleFor = (outcome: PreviousSigningOutcome, t: TFunction): string => {
  switch (outcome) {
    case PreviousSigningOutcome.Canceled:
      return t("A previous signing attempt was cancelled.");
    case PreviousSigningOutcome.Expired:
      return t("A previous signing attempt expired.");
    case PreviousSigningOutcome.Failed:
      return t("A previous signing attempt failed.");
  }
};

export const PreviousSigningInfoCard = ({ outcome }: Props) => {
  const { t } = useTranslation();
  const designContest = useDesignContestEntry();
  return (
    <Alert
      status="info"
      borderRadius="lg"
      alignItems="flex-start"
      data-testid="previous-signing-info-card"
    >
      <AlertIcon />
      <Stack spacing="1">
        <Text fontSize="sm" fontWeight="semibold">
          {titleFor(outcome, t)}
        </Text>
        <Text fontSize="sm">
          {designContest
            ? t("Edit your entry if needed, then sign again.")
            : t("Edit your offer if needed, then sign again.")}
        </Text>
      </Stack>
    </Alert>
  );
};
